import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../authentication.service';
import { AlertService } from '../components/alert/alert.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InboxservicesService {

  constructor(
    private httpClient: HttpClient,
    private authenticationService: AuthenticationService,
    private alert: AlertService,
  ) { }

  api_root: string = environment.REST_API_SERVER;


  public getApprovalBoardsList(workspaceId: any, boardId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/'+boardId+'/get_board_approvel_list/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public verifyBoard(workspaceId: any, boardId: Array<{id: any}>) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/['+ boardId +']/get_board_approved/';
    const data = {
      "tag": "tag"
    }
    return this.httpClient.post<any>(similar_url, data);
  }

  public approveBoards(workspaceId: any, boardId: Array<{id: any}>, verifyId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/['+ boardId +']-'+verifyId+'-'+workspaceId+'/approve_boards/';
    const data = {
      "tag": "tag"
    }
    return this.httpClient.post<any>(similar_url, data);
  }

  public getApprovalAssetsList(workspaceId: any, boardId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/'+boardId+'/get_asset_approvel_list/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public verifyAssets(workspaceId: any, boardId: Array<{id: any}>) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/['+ boardId +']/get_asset_approved/';
    const data = {
      "tag": "tag"
    }
    return this.httpClient.post<any>(similar_url, data);
  }

  public approveAssets(workspaceId: any, boardId: Array<{id: any}>, verifyId: any, boardEntryId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/['+ boardId +']-'+verifyId+'-'+boardEntryId+'/approve_assets/';
    const data = {
      "tag": "tag"
    }
    return this.httpClient.post<any>(similar_url, data);
  }

  public getAssetsList(workspaceId: any, boardId: Array<{id: any}>) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/['+ boardId +']/approval_board_assets_list/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }
}
